// extracted by mini-css-extract-plugin
export var locationCard = "_hq-0";